import { mdiChevronDoubleLeft, mdiChevronDoubleRight, mdiChevronLeft, mdiChevronRight } from "@mdi/js";
import { type JSX, Show } from "solid-js";
import { Button } from "~/components/ui/button";
import { ActionIcon, Icon } from "~/components/ui/icon";
import { Text } from "~/components/ui/text";
import { useWidgetApp } from "~/provider";
import { useDocumentContext } from "../../../providers/context";

interface DirectionButtonProps extends Omit<JSX.HTMLAttributes<HTMLButtonElement>, "onclick" | "onClick"> {}

export function DocumentNextArticleButton(props: DirectionButtonProps) {
	const { handleDirectionArticle } = useDocumentContext();
	const { screen } = useWidgetApp();

	const onClickNext = () => handleDirectionArticle(1);

	return (
		<Show
			when={screen() === "desktop"}
			fallback={
				<ActionIcon
					path={mdiChevronDoubleRight}
					onClick={onClickNext}
				/>
			}
		>
			<Button
				size="sm"
				onclick={onClickNext}
				variant="outline"
				{...props}
			>
				<Text>
					Volgend artikel
					<Icon path={mdiChevronRight} />
				</Text>
			</Button>
		</Show>
	);
}

export function DocumentPreviousArticleButton(props: DirectionButtonProps) {
	const { handleDirectionArticle } = useDocumentContext();
	const { screen } = useWidgetApp();

	const onClickPrevious = () => handleDirectionArticle(-1);

	return (
		<Show
			when={screen() === "desktop"}
			fallback={
				<ActionIcon
					path={mdiChevronDoubleLeft}
					onClick={onClickPrevious}
				/>
			}
		>
			<Button
				size="sm"
				onclick={onClickPrevious}
				variant="outline"
				{...props}
			>
				<Text>
					<Icon path={mdiChevronLeft} />
					Vorig artikel
				</Text>
			</Button>
		</Show>
	);
}
